export default __webpack_public_path__ + "4cf51fa3e131974c95b940315bff37fd.svg";